import { useContext, useEffect } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { LegalTexts } from "../components/LegalTexts";

export const BookingForm = () => {
	const { FLOW } = useContext(AppContext);
	const nextPage = FLOW === "mapfre" ? "intro" : "selectCenter";
	const previousPage = "";

	return (
		<>
			<Header />
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const {
		data,
		setData,
		centers,
		setCenters,
		setFilteredCenters,
		brands,
		setBrands,
		models,
		setModels,
		isTransitioning,
		errors,
		FLOW,
	} = useContext(AppContext);

	useEffect(() => {
		if (FLOW === "web" && !data.locator) {
			let API_URL =
				process.env.REACT_APP_API_URL || "http://localhost:3000";
			let TOKEN = process.env.REACT_APP_API_TOKEN;

			let controller = new AbortController();
			let options = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ token: TOKEN }),
				signal: controller.signal,
			};

			fetch(`${API_URL}/bookings`, options)
				.then((res) => res.json())
				.then((newData) => {
					setData((prevData) => ({
						...prevData,
						locator: newData.locator,
					}));
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		}
	}, [data, setData, FLOW]);

	useEffect(() => {
		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
			signal: controller.signal,
		};

		let isMounted = true;

		fetch(`${API_URL}/query/workcenters`, options)
			.then((res) => res.json())
			.then((newData) => {
				if (isMounted && newData.result === "ok") {
					const workcenters = newData.workcenters.filter(
						(center) => center.active
					);
					setCenters(workcenters);
					setFilteredCenters(workcenters);
				}
			})
			.catch((err) => {
				if (err.name !== "AbortError") console.error(err);
			});

		if (FLOW === "web" && data.locator) {
			fetch(`${API_URL}/query/brands?locator=${data.locator}`, options)
				.then((res) => res.json())
				.then((newData) => {
					if (isMounted && newData.result === "ok") {
						setBrands(newData.brands);
					}
				})
				.catch((err) => {
					if (err.name !== "AbortError") console.error(err);
				});
		}

		return () => {
			isMounted = false;
			controller.abort();
		};
	}, [data.locator, setBrands, setCenters, setFilteredCenters, FLOW]);

	useEffect(() => {
		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		if (data.brand && data.locator) {
			fetch(
				`${API_URL}/query/models?brand=${data.brand}&locator=${data.locator}`,
				options
			)
				.then((res) => res.json())
				.then((newData) => {
					if (newData.result === "ok") {
						setModels(newData.models);
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		}
	}, [data.brand, data.locator, setModels]);

	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_booking_form">
				<h2 className="booking_form_title">
					<strong>
						Solo necesitamos estos datos para iniciar tu cita
					</strong>
				</h2>
				{FLOW === "mapfre" && (
					<form>
						<label>
							<strong>Nombre y Apellidos</strong>
							<input
								type="text"
								defaultValue={data?.userName || ""}
								onChange={(e) =>
									setData({
										...data,
										userName: e.target.value,
									})
								}
							/>
							{errors.name && (
								<span className="error">{errors.name}</span>
							)}
						</label>
						<label>
							<strong>Teléfono</strong>
							<input
								type="tel"
								defaultValue={data ? data.phoneNumber : ""}
								onChange={(e) =>
									setData({
										...data,
										phoneNumber: e.target.value,
									})
								}
							/>
							{errors.phone && (
								<span className="error">{errors.phone}</span>
							)}
						</label>
						<label>
							<strong>Email</strong>
							<input
								type="email"
								defaultValue={data ? data.userEmail : ""}
								onChange={(e) =>
									setData({
										...data,
										userEmail: e.target.value,
									})
								}
							/>
							{errors.email && (
								<span className="error">{errors.email}</span>
							)}
						</label>
						<label>
							<strong>Matrícula</strong>
							<input
								type="text"
								defaultValue={data ? data.plateNumber : ""}
								onChange={(e) =>
									setData({
										...data,
										plateNumber: e.target.value,
									})
								}
							/>
							{errors.plate && (
								<span className="error">{errors.plate}</span>
							)}
						</label>
						<label>
							<strong>Taller</strong>
							<select
								value={data?.workCenterCode || ""}
								onChange={(e) =>
									setData({
										...data,
										workCenterCode: e.target.value,
									})
								}
							>
								<option value="">Selecciona un taller</option>
								{centers &&
									centers.map((center) => (
										<option
											key={center.id}
											value={center.id}
										>
											{center.name}
										</option>
									))}
							</select>
							{errors.centerCode && (
								<span className="error">
									{errors.centerCode}
								</span>
							)}
						</label>
					</form>
				)}
				{FLOW === "web" && (
					<form>
						<label>
							<strong>Teléfono</strong>
							<input
								type="tel"
								value={data?.phone || ""}
								onChange={(e) =>
									setData({
										...data,
										phone: e.target.value,
									})
								}
							/>
							{errors.phone && (
								<span className="error">{errors.phone}</span>
							)}
						</label>
						<label>
							<strong>Matrícula</strong>
							<input
								type="text"
								value={data?.plate || ""}
								onChange={(e) =>
									setData({
										...data,
										plate: e.target.value,
									})
								}
							/>
							{errors.plate && (
								<span className="error">{errors.plate}</span>
							)}
						</label>
						<label>
							<strong>Marca vehículo</strong>
							<select
								value={data?.brand || ""}
								onChange={(e) =>
									setData({
										...data,
										brand: e.target.value,
										model: "",
									})
								}
							>
								<option value="">Selecciona marca</option>
								{brands &&
									brands.map((brand) => (
										<option key={brand} value={brand}>
											{brand}
										</option>
									))}
							</select>
							{errors.brand && (
								<span className="error">{errors.brand}</span>
							)}
						</label>
						<label>
							<strong>Modelo</strong>
							<select
								value={data?.model || ""}
								disabled={!data.brand}
								onChange={(e) =>
									setData({ ...data, model: e.target.value })
								}
							>
								<option value="">Selecciona modelo</option>
								{models &&
									models.map((model, index) => (
										<option key={index} value={model}>
											{model}
										</option>
									))}
							</select>
							{errors.model && (
								<span className="error">{errors.model}</span>
							)}
						</label>
						<label className="privacy_policy">
							<input
								type="checkbox"
								checked={!!(data && data.privacy_policy)}
								onChange={(e) =>
									setData({
										...data,
										privacy_policy: e.target.checked,
									})
								}
							/>
							<span className="link">
								Acepto la{" "}
								<a
									href="https://www.ralarsa.com/es/privacidad/"
									target="_blank"
									rel="noopener noreferrer"
								>
									política de privacidad
								</a>
							</span>
						</label>
					</form>
				)}
				<LegalTexts />
			</div>
		</div>
	);
};
